import { useCallback, useState } from 'react'
import axios from '@fs/zion-axios'
import useFetchData from './useFetchData'
import getIdentBaseUrl from '../utils/getIdentBaseUrl'
import { InvalidCharacterUsernameError, InvalidUsernameError, UsernameAlreadyInUseError } from '../errors'

const fetchUsername = async () => {
  const { data } = await axios.get(`${getIdentBaseUrl()}/service/ident/authn/accounts/CURRENT/username`, {
    headers: { accept: 'application/account.v2+json' },
  })
  return data?.username || null
}

const AuthnErrorCodeToUsernameError = {
  147: UsernameAlreadyInUseError,
  149: InvalidUsernameError,
  155: InvalidCharacterUsernameError,
}

const updateUsername = async (newUsername) => {
  try {
    await axios.put(
      `${getIdentBaseUrl()}/service/ident/authn/accounts/CURRENT/username`,
      { username: newUsername },
      {
        headers: { accept: 'application/account.v2+json' },
      }
    )
  } catch (error) {
    if (error.response?.status === 409) {
      throw new UsernameAlreadyInUseError()
    } else if (error.response?.data?.errors) {
      const MappedError = AuthnErrorCodeToUsernameError[error.response.data.errors[0].key]
      if (MappedError) {
        throw new MappedError()
      }
    }
    throw error
  }
}

export default function useUsername() {
  const { data: remoteUsername, loading: usernameLoading } = useFetchData(fetchUsername)
  const [localUsername, setLocalUsername] = useState(null)

  const handleChangeUsername = useCallback(async (newUsername) => {
    await updateUsername(newUsername)
    setLocalUsername(newUsername)
  }, [])

  const username = localUsername ?? remoteUsername

  return {
    username,
    usernameLoading,
    handleChangeUsername,
  }
}
